class RecommendeProducts extends HTMLElement {
    constructor() {
        super()
        this.elements = {
            visit: this.querySelector(`button#visit_${this.dataset.section}`),
            later: this.querySelector(`button#later_${this.dataset.section}`),
            close: this.querySelector(`a.close`)
        }

        this.addEventListener("click", (e) => this.handleOpen(e));
        this.onkeypress = (e) => {
            if (e.key === "Enter") {
                this.click();
            }
        }

        if (this.elements.visit) {
            this.elements.visit.addEventListener("click", (e) => this.handleVisit(e), {passive: true})
        }

        if (this.elements.later) {
            this.elements.later.addEventListener("click", (e) => this.handleLater(e), {passive: true})
        }


        if (this.elements.close) {
            this.elements.close.addEventListener("click", (e) => this.parentElement.style.display = "none", {passive: true})
        }

        if (!(location.pathname == this.dataset.product || localStorage?.getItem(`recommended_product_show`) == 'false')) {
            this.handleOpen(null);
        } else {
            if(!this.parentElement?.classList.contains("ml_layout_float")) {
                this.parentElement?.classList.add("ml_layout_float");
                this.parentElement?.classList.remove("ml_layout_pop_up");
                this.parentElement?.classList.add("ml_layout_pop_up_rep");
            }
        }

        if(this.clientWidth > 0 && this.clientHeight > 0) {
            this.parentElement?.classList.remove("ml_recc_first_hide");
        }
    }

    handleVisit(e) {
        console.log(this.dataset.product);
        if (this.dataset.product) {
            // this.handleLater(null);
            this.elements.close?.click();
            location.href = this.dataset.product;
        }
    }

    handleLater(e) {
        this.style.width = '';
        this.style.height = '';
        setTimeout(() => {
            localStorage?.setItem(`recommended_product_show`, 'false');
            if(!this.parentElement?.classList.contains("ml_layout_float")) {
                this.parentElement?.classList.add("ml_layout_float");
                this.parentElement?.classList.remove("ml_layout_pop_up");
                this.parentElement?.classList.add("ml_layout_pop_up_rep");
            }
            this.classList.add("ml_recommended_closed");
            this.classList.remove("ml_recommended_opened");
        })
    }

    handleOpen(e) {
        if (this.classList.contains("ml_recommended_closed")) {
            // setTimeout(() => {
            //     const width = `${this.clientWidth}px`;
            //     const height = `${this.clientHeight}px`;

            //     this.style.width = "80px";
            //     this.style.height = "80px";

            //     this.classList.add("ml_recommended_open_hide");
            //     setTimeout(() => {
            //         this.style.width = width;
            //         this.style.height = height;
            //         setTimeout(() => {
            //             setTimeout(() => {
            //                 this.classList.remove("ml_recommended_closed_temp");
            //             }, 100);
            //             this.classList.remove("ml_recommended_open_hide");
            //         }, 300)
            //     });
            // });
            // this.classList.add("ml_recommended_closed_temp");


            if(this.parentElement?.classList.contains("ml_layout_pop_up_rep")) {
                this.parentElement?.classList.add("ml_layout_pop_up");
                this.parentElement?.classList.remove("ml_layout_float");
                this.parentElement?.classList.remove("ml_layout_pop_up_rep");
            }

            this.classList.add("ml_recommended_opened");
            this.classList.remove("ml_recommended_closed");
            localStorage?.removeItem(`recommended_product_show`);
        }
    }
}
customElements.define('recommended-products', RecommendeProducts);